const timeAgoUnit = {
  years: 365 * 24 * 60 * 60 * 1000,
  months: 30 * 24 * 60 * 60 * 1000,
  weeks: 7 * 24 * 60 * 60 * 1000,
  days: 24 * 60 * 60 * 1000,
  hours: 60 * 60 * 1000,
  minutes: 60 * 1000,
  seconds: 1000,
};

export type TimeAgoUnits = keyof typeof timeAgoUnit;

export function timeAgo(
  date: Date,
  minUnit: TimeAgoUnits = 'seconds',
  since = new Date(),
): [string, TimeAgoUnits, number] | null {
  const diff = date.getTime() - since.getTime();
  const units = Object.keys(timeAgoUnit) as Array<TimeAgoUnits>;
  const minIdx = units.indexOf(minUnit);

  const unit = units.find(
    (key, i) => i === minIdx || Math.abs(diff) > timeAgoUnit[key],
  );
  if (!unit) return null;

  const quantity = Math.floor(diff / timeAgoUnit[unit]);
  return [
    new Intl.RelativeTimeFormat('en-CA', {
      numeric: 'always',
      style: 'short',
    }).format(quantity, unit),
    unit,
    quantity,
  ];
}
